module.exports = __webpack_public_path__ + "files/103be396b92365a5944f6d930f03137a.png";